import React from 'react'
import Typography from '@material-ui/core/Typography';
const TopicHeader=({text})=>{
     return <React.Fragment>
            <Typography style={{textTransform:'uppercase',fontSize:'16px',fontWeight:'bold'}}>{text}</Typography>
            <img src={`/images/icon-our.png`} style={{width:100,marginBottom:'1rem'}}></img>
    </React.Fragment>
}
export default TopicHeader;